import { OutlineInputControl } from '__components/Inputs/InputControl';

import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Automation } from 'store/automationsPage/automations.redux';
import YesNoMaybe from '__components/Inputs/YesNoMaybe';
import { GenericOption } from 'pages/AutomationEngine/types';
import { useMemo } from 'react';

type TypeChooser = {
  automationType: Automation['type'];
  setAutomationType: (type: Automation['type']) => void;
  typeKeyboardProps: any;
};

const ChooserInputControl = styled(OutlineInputControl)`
  margin-bottom: 17px;
  button {
    min-width: calc(50% - 5px);
  }
`;

export const TypeChooser = (props: TypeChooser) => {
  const { t } = useTranslation();

  const { automationType, setAutomationType, typeKeyboardProps } = props;

  const options: GenericOption<Automation['type']>[] = useMemo(
    () => [
      {
        value: 'record_based',
        label: t('Record Based'),
      },
      {
        value: 'global',
        label: t('Global'),
      },
    ],
    [t]
  );

  return (
    <ChooserInputControl
      label="Agentic Workflow Type"
      labelInfo={t(
        `Record-based agentic workflows run in context of a specific entity record in a custom object within Kizen. Global agentic workflows can be triggered outside of core data models and are typically used for agentic workflows that run on schedules, from external webhooks, or other submissions that don't directly link to a specific record.`
      )}
      data-qa="automation-type"
      dataQa="automation-type"
    >
      <YesNoMaybe
        value={automationType}
        options={options}
        fieldId={typeKeyboardProps.fieldId}
        onChange={(e: GenericOption<Automation['type']>) =>
          setAutomationType(e.value)
        }
        required
      />
    </ChooserInputControl>
  );
};
